const MAX_SPEED = 300; // [px / s]
const DIST = 100;

export default class Follower extends Phaser.Group {
  constructor(game, followerId, seeker) {
    super(game);
    this.followerId = followerId;
    this.seeker = seeker;

    this.onPosition = new Phaser.Signal();
    this.onAnimEnd = new Phaser.Signal();

    //
    this.skin = this.game.make.spine(0, 0, followerId, true);
    this.skin.anchor.set(0.5, 1);
    this.addChild(this.skin);

    this.update();
    this.updateTransform();

    // animations
    this.skin.setMixByName('walk', 'idle', 0.25);
    this.skin.setMixByName('idle', 'walk', 0.25);

    this.currentAnim = '';
    this.playAnim('idle');

    this.skin.setSkinByName('base');

    //
    this.x = this.destX = this.seeker.x - DIST; // this.navPoints[this.currentNavId];

    //
    this.skin.skeleton.getRootBone().scaleX = 0.4;
    this.skin.skeleton.getRootBone().scaleY = 0.4;
  }

  playAnim(anim, loop = true) {
    if (this.currentAnim !== anim) {
      this.currentAnim = anim;
      this.skin.setAnimationByName(0, anim, loop);
      // const track = this.skin.setAnimationByName(0, anim, loop);
      //
      // // tricky fix for walk anim speed
      // if (anim === 'walk') {
      //   track.timeScale = 0.6;
      // } else {
      //   track.timeScale = 1;
      // }
    }
  }

  setPosition(x) {
    this.x = this.destX = x;
    this.playAnim('idle');
  }

  gotoPosition(x) {
    this.destX = x;

    const dir = this.destX > this.x ? 1 : -1;
    this.setDirection(-dir);

    this.playAnim('walk');
  }

  step(dt) {
    const dx = this.seeker.x - this.x;
    if (Math.abs(dx) > DIST) {
      const sign = dx > 0 ? 1 : -1;
      this.gotoPosition(this.seeker.x - sign * DIST);
    }

    if (this.destX !== this.x) {
      const dx0 = this.destX - this.x;
      const dir = this.destX > this.x ? 1 : -1;
      const dx = Math.min(Math.abs(dx0), MAX_SPEED * dt);
      this.x += dir * dx;

      this.setDirection(-dir);
    } else if (this.currentAnim === 'walk') {
      this.playAnim('idle');
    }
  }

  setDirection(dir) {
    this.skin.skeleton.getRootBone().scaleX = 0.4 * dir;
    // this.update();
    // this.updateTransform();
  }
}
